export default "__VITE_ASSET__Bbi1j7p$__"